import styled from 'styled-components'
import { TableCell, TableCellLayout, TableHeaderCell } from '@fluentui/react-components'

import { colors, device, fontSize, media } from '../../theme'
import FileIcon from '../File/FileIcon'
import Icons from '../../assets/Icons'
import Button from '../../controls/Button'

export const CustomFileIcon = styled(FileIcon)`
  width: 32px;
  height: 32px;
`
export const TheeDotsCellLayout = styled(TableCellLayout)`
  justify-content: flex-end;
`
export const CustomTableTd = styled.td`
  text-align: center;
  margin: 20px 0;
`
export const NoDataText = styled.span`
  color: ${colors.textMuted};
  font-size: ${fontSize.sm};
  font-weight: 500;
`
export const FolderButtonWrapper = styled(TableCellLayout)`
  div {
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      // background-color: #eeeff2;
      width: 32px;
      height: 32px;
    }
  }
`
export const FolderButton = styled(Icons)`
  border: none;
  svg {
    color: #3468b2;
    width: 32px;
    height: 32px;
  }
`
export const FooterBtn = styled(Button)`
    border-width:  2px;
    border-style: solid;
    border-radius: 16px;
    min-height: 32px;
    height: auto;
    min-width: 72px;
    padding: 3px 14px 5px;
    font-size": 14px;
    font-weight: 700;
`
export const FooterBtnWrapper = styled.div`
  width: 100%;
  display: flex;
  column-gap: 10px;
  justify-content: flex-end;
`
export const CustomButton = styled(Button)`
  border-width: 2px;
  border-style: solid;
  border-radius: 16px;
  min-height: 32px;
  height: auto;
  min-width: 72px;
  padding: 3px 14px 5px;
  font-size: 14px;
  font-weight: 700;
`

export const Content = styled.div`
  padding: 0 1.5rem;
  flex: 1 1;
  // overflow: auto;
  min-height: 200px;
  padding: 1rem;
  // height: 50%;
  ${media.down(device.tablet)`
    position: absolute;
    top: 62px;
    bottom: 60px;
    left: 0;
    right: 0;
    height: 100%;
  `}

  ${media.down(device.mobile)`
    top: 52px;
  `}
`

export const TableRowCell = styled(TableCell)`
    color: var(--text);
    font-size: var(--fontSizeBase200);
    font-weight: var(--fontWeightRegular);
    line-height: var(--lineHeightBase200);
`

export const TableRowHeaderCell = styled(TableHeaderCell)`
    color: var(--text);
    font-size: var(--fontSizeBase100);
    font-weight: var(--fontWeightBold);
    line-height: var(--lineHeightBase100);
`